export function initTabs() {
	const tabContainers = document.querySelectorAll(".switch-tab");
	if (!tabContainers.length) return;

	tabContainers.forEach((container) => {
		// Find all tab buttons within this container, but exclude nested switch-tab buttons
		const tabBtns = container.querySelectorAll(".tab-btn");
		const tabContents = container.querySelectorAll(".tab-content");

		// Filter to only include buttons that belong to this container (not nested)
		const ownBtns = [...tabBtns].filter(
			(btn) => btn.closest(".switch-tab") === container,
		);
		const ownContents = [...tabContents].filter(
			(content) => content.closest(".switch-tab") === container,
		);

		ownBtns.forEach((btn) => {
			btn.addEventListener("click", function () {
				// Only affect buttons within same container
				ownBtns.forEach((b) => {
					b.classList.remove("active");
					b.classList.add("inactive");
				});

				this.classList.remove("inactive");
				this.classList.add("active");

				// Only affect content within same container
				ownContents.forEach((c) => c.classList.add("hidden"));

				const targetId = this.getAttribute("data-tab");
				const targetContent = document.getElementById(targetId);
				if (targetContent) {
					targetContent.classList.remove("hidden");
				}
			});
		});
	});
}
